import { Menu, Button, rem } from "@mantine/core"
import {
  IconCalendar,
  IconBrandOffice,
  IconBrandGoogle,
  IconBrandApple,
} from "@tabler/icons-react"
import { WebCalendarProfileDto } from "../../../../../@client/Theasoft_Shared_Contracts_WebCalendar"
import { useTranslation } from "react-i18next"
import { AddToGoogleCalendarModal } from "./add-to-google-calendar-modal"

function openProfileAsExternal(
  calendar: WebCalendarProfileDto,
  app: "outlook" | "apple"
) {
  const isSupportingWebcals = app === "outlook"
  const url =
    isSupportingWebcals && calendar.webcalsLink && calendar.webcalsLink !== ""
      ? calendar.webcalsLink
      : calendar.webcalLink

  window.location.href = url
}

interface Props {
  profile: WebCalendarProfileDto
}

export function SubscribeMenuButton({ profile }: Props) {
  const { t } = useTranslation("app_server")
  const [googleCalendarModalOpen, setGoogleCalendarModalOpen] =
    React.useState(false)
  return (
    <>
      <Menu
        transitionProps={{ transition: "pop-top-right" }}
        width={220}
        withinPortal
      >
        <Menu.Target>
          <Button
            leftSection={<IconCalendar size={14} />}
            variant="subtle"
            size="xs"
          >
            {t("Subscribe")}
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            onClick={() => openProfileAsExternal(profile, "outlook")}
            leftSection={
              <IconBrandOffice
                style={{
                  width: rem(16),
                  height: rem(16),
                }}
                stroke={1.5}
              />
            }
          >
            Outlook {t("Calendar")}
          </Menu.Item>
          <Menu.Item
            onClick={() => setGoogleCalendarModalOpen(true)}
            leftSection={
              <IconBrandGoogle
                style={{
                  width: rem(16),
                  height: rem(16),
                }}
                stroke={1.5}
              />
            }
          >
            Google {t("Calendar")}
          </Menu.Item>
          <Menu.Item
            onClick={() => openProfileAsExternal(profile, "apple")}
            leftSection={
              <IconBrandApple
                style={{
                  width: rem(16),
                  height: rem(16),
                }}
                stroke={1.5}
              />
            }
          >
            Apple {t("Calendar")}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
      <AddToGoogleCalendarModal
        opened={googleCalendarModalOpen}
        onClose={() => setGoogleCalendarModalOpen(false)}
        url={profile.externalLink}
      />
    </>
  )
}
